/* eslint-disable no-param-reassign */
import { Editor, Transforms, Element, Path, Node } from 'slate';
import { ListFormat, BaseBlockFormat, ListItemElement } from '../types';

const LIST_TYPES = Object.values(ListFormat);

const withList = (editor: any) => {
	const { insertBreak } = editor;

	editor.insertBreak = () => {
		const { selection } = editor;
		if (selection) {
			const [listItem] = Editor.nodes(editor, {
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && n.type === ListFormat.ITEM,
			});

			if (listItem) {
				const [node, path] = listItem as [ListItemElement, Path];
				// Check if the list item is empty (only one child with empty text)
				const isEmpty = node.children.length === 1 && node.children[0].text === '';

				if (isEmpty) {
					// Lift the empty list item out of the list
					Transforms.liftNodes(editor, { at: path });
					// Now change it to a paragraph
					Transforms.setNodes(editor, {
						type: BaseBlockFormat.PARAGRAPH,
					});
					return;
				}
			}
		}

		// Default behavior
		insertBreak();
	};

	return editor;
};

export default withList;
